import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "c-story-card__inner" }
const _hoisted_3 = {
  key: 0,
  class: "c-story-card__media"
}
const _hoisted_4 = { class: "c-story-card__content" }

import { computed } from 'vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import AdaptiveMedia from '@/elements/AdaptiveMedia.vue';
import type { StoryCardProps } from '@/types/components/StoryCard';
import utils from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'StoryCard',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);
const mediaField = computed(() => fields.value?.image);
const hasMedia = computed(() => {
  const mediaFields = mediaField.value?.fields;

  return !!(
    mediaFields?.desktopImage?.value?.src ||
    mediaFields?.mobileImage?.value?.src ||
    mediaFields?.desktopVideo?.value?.src ||
    mediaFields?.desktopVideo?.value?.href ||
    mediaFields?.mobileVideo?.value?.src ||
    mediaFields?.mobileVideo?.value?.href
  );
});

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'c-story-card'));
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});

return (_ctx: any,_cache: any) => {
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value),
        id: __props.rendering?.dataSource
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [3, 18],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("article", _hoisted_2, [
              (hasMedia.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(AdaptiveMedia, {
                      class: "c-story-card__adaptive-media",
                      field: mediaField.value,
                      "show-play-button": true,
                      autoplay: true,
                      loop: true,
                      controls: true,
                      "has-controls": true,
                      "show-image-redius": false
                    }, null, 8, ["field"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                (fields.value.title?.value)
                  ? (_openBlock(), _createBlock(_unref(RichText), {
                      key: 0,
                      class: "c-story-card__title",
                      field: fields.value.title
                    }, null, 8, ["field"]))
                  : _createCommentVNode("", true),
                (fields.value.description?.value)
                  ? (_openBlock(), _createBlock(_unref(RichText), {
                      key: 1,
                      class: "c-story-card__description",
                      field: fields.value.description
                    }, null, 8, ["field"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})